import { useEffect, useState, type ReactNode } from 'react';
import { AuthState, useIdentify } from '../../hooks/useIdentify';

type Props = {
  onNotCheckedOut: () => void;
  onNotLoggedIn: () => void;
  children: ReactNode;
};

export function RequireCheckedOut({
  children,
  onNotCheckedOut,
  onNotLoggedIn,
}: Props) {
  const [authenticated, setAuthenticated] = useState(false);
  const customer = useIdentify();

  const { authState, customerData } = customer;

  useEffect(() => {
    switch (authState) {
      case AuthState.isAnonymous: {
        onNotLoggedIn();
        return;
      }
      case AuthState.isAuthenticated: {
        const { did_checkout: didCheckout } = customerData;
        if (didCheckout === false) {
          onNotCheckedOut();
          return;
        }
        setAuthenticated(true);
        return;
      }
    }
  }, [
    authState,
    customerData,
    onNotCheckedOut,
    setAuthenticated,
    onNotLoggedIn,
  ]);

  if (authenticated === false) {
    return null;
  }

  return <>{children}</>;
}
